import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { InvoicingCutoffService } from './../../../../services/invoicing/invoicing-cutoff.service';

@Component({
  selector: 'app-invoice-printing-range',
  templateUrl: './invoice-printing-range.component.html',
  styleUrls: ['./invoice-printing-range.component.scss'],
  standalone: false
})
export class InvoicePrintingRangeComponent implements OnInit {

  branchId: number = 0;
  bussinessDocumentsTypeClassId: number = BussinessDocumentsClassEnums.factura;
  enterpriseId: number = 0;
  final: number = 0;
  formPrintingRange: FormGroup = new FormGroup({});
  invoiceModel: InvoiceModel = new InvoiceModel();
  initial: number = 0;
  listInvoiceTraffic: CustomListDropdown[] = [
    { label: "ORIGINAL CLIENTE", value: 1 },
    { label: "COPIA CLIENTE", value: 2 },
    { label: "ORIGINAL CARTERA", value: 3 },
    { label: "ARCHIVO", value: 4 },
    { label: "COPIA", value: 5 },
    { label: "CONTABILIDAD", value: 6 },
    { label: "ORIGINAL EMPRESA", value: 7 },
    { label: "ORIGINAL", value: 8 },
    { label: "CLIENTE", value: 9 }
  ];
  suscription: Subscription;

  constructor(private formBuilder: FormBuilder,
    private invoicingCutoffService: InvoicingCutoffService,
    private invoiceService: InvoiceService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm();
  }

  async ngOnInit(): Promise<void> {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.invoiceModel = inputs.invoiceModel;
    });

    if (this.invoiceModel.invoiceId != 0 && this.invoiceModel.invoiceId != -1) {
      //Válido si la fra tiene corte

      this.invoiceModel.invoicingCutoffId == null ? this.formPrintingRange.controls["invoicingCutoff"].disable() : this.formPrintingRange.controls["invoicingCutoff"].enable();
      this.formPrintingRange.controls["consecutiveInitial"].patchValue(this.invoiceModel.consecutive);
      this.formPrintingRange.controls["consecutiveFinal"].patchValue(this.invoiceModel.consecutive);
    }
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async changeInvoicingCutoff() {
    const consecutive = this.formPrintingRange.get("invoicingCutoff")?.value;
    if (consecutive != 0 && consecutive != null) {
      try {
        const response = await firstValueFrom(this.invoicingCutoffService.getInitialAndFinalInvoiceByKeysAsync(this.invoiceModel.branchId, consecutive));
        if (response.initialInvoice != null && response.initialInvoice != 0 && response.finalInvoice != null && response.finalInvoice != 0) {
          this.formPrintingRange.controls["consecutiveInitial"].patchValue(response.initialInvoice);
          this.formPrintingRange.controls["consecutiveFinal"].patchValue(response.finalInvoice);
        }
      } catch (error) {
        console.error('Error al buscar el corte por llaves.', error);
      }
    }
  }

  async getPrintInvoices(traffic: string) {
    try {
      const invoicePrints = await firstValueFrom(this.invoiceService.printsInvoices(this.invoiceModel.invoiceId, this.initial, this.final, true));
      const data: ModalObjectType = {};
      data.params = {
        traffic: traffic,
        invoicesPrint: invoicePrints
      };
      this.ref.close(data);
      //Limpio campos
      this.validateForm();
    } catch (error) {
      console.error('Error al imprimir las facturas.', error);
    }
  }

  async send() {
    if (this.formPrintingRange.valid) {
      this.initial = this.formPrintingRange.get("consecutiveInitial")?.value;
      this.final = this.formPrintingRange.get("consecutiveFinal")?.value;
      const element = this.listInvoiceTraffic.find(x => x.value == this.formPrintingRange.get("invoiceTraffic")?.value);
      this.toastHandlerService.clearAllToasts();
      await this.getPrintInvoices(element!.label);

    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Todos los campos marcados con (*) son obligatorios.'
      );
    }
  }

  validateForm() {
    this.formPrintingRange = this.formBuilder.group({
      invoicingCutoff: [0, []],
      consecutiveInitial: [0, [Validators.min(1)]],
      consecutiveFinal: [0, [Validators.min(1)]],
      invoiceTraffic: [0, [Validators.min(1)]]
    });
  }

}
